module.exports = __webpack_public_path__ + "img/i_PDFreport.f4ac1fb1.svg";